import React from "react";

function CeritaDanai() {
    return (
        <>
            <div className="container-cerita-danai">
                <div className="explanation-box">
                    <div className="title">
                        <h2 className="text-header">Mengapa Kami Ada di Industri Ini</h2>
                    </div>
                    <div className="explanation">
                        <p>
                            Para pendiri <strong>Danai.id</strong> merupakan para praktisi perbankan yang melihat adanya kesenjangan besar
                            dalam akses layanan keuangan di Indonesia. Sebagian masyarakat telah menikmati layanan keuangan dengan baik, sementara sebagian
                            lainnya belum merasakan manfaat tersebut (terutama kelompok berpendapatan rendah). Kesenjangan ini
                            menunjukkan bahwa pertumbuhan ekonomi belum sepenuhnya dinikmati oleh semua golongan.
                        </p>
                        <p>
                            Karena itu, <strong>Danai.id hadir untuk menjembatani kesenjangan tersebut dengan mengandalkan solusi
                            berbasis teknologi dengan tujuan memberikan akses layanan keuangan bagi seluruh lapisan masyarakat.</strong>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CeritaDanai;